export default __webpack_public_path__ + "static/media/logo-h-with-text-dark.529cf21f.png";